import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import {
  Box,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  Menu,
  MenuButton,
  MenuList,
  MenuItemOption,
  MenuOptionGroup,
  Button,
  Icon,
} from '@chakra-ui/react';

import { FaSearch, FaFilter } from 'react-icons/fa';

import { useColors } from './colors';

import { getSuppliersListApi } from 'features/suppliers/suppliers.api';
import { getMarketplacesListApi } from 'features/marketplaces/marketplaces.api';

const FiltersSection = ({
  searchValue,
  selectedStatus,
  selectedMarketplace,
  selectedSuppliers,
  onSearch,
  onStatusChange,
  onMarketplaceChange,
  onSuppliersChange,
  onSearchSubmit,
  marketplaces = [],
  suppliers = [],
}) => {
  const dispatch = useDispatch();
  const { textColor, bgCard, inputBgColor, borderColor } = useColors();

  useEffect(() => {
    dispatch(getSuppliersListApi());
    dispatch(getMarketplacesListApi());
  }, [dispatch]);

  const handleSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      onSearchSubmit(e.target.value);
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    onSearch(value);
    if (value === '') {
      onSearchSubmit('');
    }
  };

  return (
    <Box bg={bgCard} borderRadius="lg" boxShadow="sm" p={6} mb={4}>
      <Flex
        direction={{ base: 'column', md: 'row' }}
        gap={4}
        align={{ base: 'stretch', md: 'center' }}
      >
        {/* Search Bar */}
        <InputGroup maxW={{ base: '100%', md: '400px' }}>
          <InputLeftElement pointerEvents="none" h="full" pl={4}>
            <Icon as={FaSearch} color="gray.400" boxSize={5} />
          </InputLeftElement>
          <Input
            value={searchValue}
            onChange={handleSearchChange}
            onKeyPress={handleSearchKeyPress}
            placeholder="Search stores..."
            color={textColor}
            bg={inputBgColor}
            _placeholder={{ color: 'gray.400' }}
            borderRadius="lg"
            size="lg"
            pl={12}
          />
        </InputGroup>

        <Flex
          gap={4}
          flex={1}
          justify="flex-end"
          direction={{ base: 'column', md: 'row' }}
        >
          {/* Status Filter */}
          <Menu closeOnSelect={false}>
            <MenuButton
              as={Button}
              rightIcon={<FaFilter />}
              bg={inputBgColor}
              color={textColor}
              borderColor={borderColor}
              variant="outline"
              size="lg"
              borderRadius="lg"
              minW="150px"
            >
              Status
            </MenuButton>
            <MenuList>
              <MenuOptionGroup
                type="checkbox"
                value={selectedStatus}
                onChange={onStatusChange}
              >
                <MenuItemOption value="sync-active">Sync Active</MenuItemOption>
                <MenuItemOption value="sync-inactive">Sync Inactive</MenuItemOption>
              </MenuOptionGroup>
            </MenuList>
          </Menu>

          {/* Marketplace Filter */}
          <Menu closeOnSelect={false}>
            <MenuButton
              as={Button}
              rightIcon={<FaFilter />}
              bg={inputBgColor}
              color={textColor}
              borderColor={borderColor}
              variant="outline"
              size="lg"
              borderRadius="lg"
              minW="180px"
            >
              Marketplace
            </MenuButton>
            <MenuList>
              <MenuOptionGroup
                type="checkbox"
                value={selectedMarketplace}
                onChange={onMarketplaceChange}
              >
                {marketplaces?.map((marketplace) => (
                  <MenuItemOption key={marketplace.id} value={marketplace.value}>
                    {marketplace.label}
                  </MenuItemOption>
                ))}
              </MenuOptionGroup>
            </MenuList>
          </Menu>

          {/* Suppliers Filter */}
          <Menu closeOnSelect={false}>
            <MenuButton
              as={Button}
              rightIcon={<FaFilter />}
              bg={inputBgColor}
              color={textColor}
              borderColor={borderColor}
              variant="outline"
              size="lg"
              borderRadius="lg"
              minW="160px"
            >
              Suppliers
            </MenuButton>
            <MenuList>
              <MenuOptionGroup
                type="checkbox"
                value={selectedSuppliers}
                onChange={onSuppliersChange}
              >
                {suppliers?.map((supplier) => (
                  <MenuItemOption key={supplier.id} value={supplier.value}>
                    {supplier.label}
                  </MenuItemOption>
                ))}
              </MenuOptionGroup>
            </MenuList>
          </Menu>
        </Flex>
      </Flex>
    </Box>
  );
};

export default FiltersSection;
